/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Smart Sash Admin API
 * RESTful API for Smart Sash device management, user authentication, and system administration
 * OpenAPI spec version: 0.13.0.0
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  Certification,
  CertificationAttemptDTOPaginationResult,
  CertificationDTO,
  CertificationDTOPaginationResult,
  CertificationQuestion,
  CreateCertificationQuestionRequest,
  GetApiCertificationAttemptsParams,
  GetApiCertificationListParams,
  GetApiCertificationParams,
  GetApiCertificationQuestionsParams,
  ProblemDetails,
  ResetCertificationRequest,
  ResetCertificationResultDTO,
  UpdateCertificationQuestionRequest
} from '../../models';

import { customInstance } from '../../../http/customInstance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getApiCertification = (
    params?: GetApiCertificationParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<CertificationDTO[]>(
      {url: `/api/Certification`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetApiCertificationInfiniteQueryKey = (params?: GetApiCertificationParams,) => {
    return [
    'infinite', `/api/Certification`, ...(params ? [params] : [])
    ] as const;
    }

export const getGetApiCertificationQueryKey = (params?: GetApiCertificationParams,) => {
    return [
    `/api/Certification`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiCertificationInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getApiCertification>>>, TError = unknown>(params?: GetApiCertificationParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiCertification>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCertificationInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCertification>>> = ({ signal }) => getApiCertification(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiCertification>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCertificationInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCertification>>>
export type GetApiCertificationInfiniteQueryError = unknown


export function useGetApiCertificationInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiCertification>>>, TError = unknown>(
 params: undefined |  GetApiCertificationParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiCertification>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCertification>>,
          TError,
          Awaited<ReturnType<typeof getApiCertification>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCertificationInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiCertification>>>, TError = unknown>(
 params?: GetApiCertificationParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiCertification>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCertification>>,
          TError,
          Awaited<ReturnType<typeof getApiCertification>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCertificationInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiCertification>>>, TError = unknown>(
 params?: GetApiCertificationParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiCertification>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCertificationInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiCertification>>>, TError = unknown>(
 params?: GetApiCertificationParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiCertification>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCertificationInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetApiCertificationQueryOptions = <TData = Awaited<ReturnType<typeof getApiCertification>>, TError = unknown>(params?: GetApiCertificationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCertification>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCertificationQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCertification>>> = ({ signal }) => getApiCertification(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCertification>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCertificationQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCertification>>>
export type GetApiCertificationQueryError = unknown


export function useGetApiCertification<TData = Awaited<ReturnType<typeof getApiCertification>>, TError = unknown>(
 params: undefined |  GetApiCertificationParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCertification>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCertification>>,
          TError,
          Awaited<ReturnType<typeof getApiCertification>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCertification<TData = Awaited<ReturnType<typeof getApiCertification>>, TError = unknown>(
 params?: GetApiCertificationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCertification>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCertification>>,
          TError,
          Awaited<ReturnType<typeof getApiCertification>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCertification<TData = Awaited<ReturnType<typeof getApiCertification>>, TError = unknown>(
 params?: GetApiCertificationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCertification>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCertification<TData = Awaited<ReturnType<typeof getApiCertification>>, TError = unknown>(
 params?: GetApiCertificationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCertification>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCertificationQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postApiCertification = (
    certification?: Certification,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<CertificationDTO>(
      {url: `/api/Certification`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: certification, signal
    },
      options);
    }




export const getPostApiCertificationMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCertification>>, TError,{data?: Certification}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiCertification>>, TError,{data?: Certification}, TContext> => {

const mutationKey = ['postApiCertification'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCertification>>, {data?: Certification}> = (props) => {
          const {data} = props ?? {};

          return  postApiCertification(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiCertificationMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCertification>>>
    export type PostApiCertificationMutationBody = Certification | undefined
    export type PostApiCertificationMutationError = ProblemDetails

    export const usePostApiCertification = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCertification>>, TError,{data?: Certification}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiCertification>>,
        TError,
        {data?: Certification},
        TContext
      > => {
      return useMutation(getPostApiCertificationMutationOptions(options), queryClient);
    }
    export const getApiCertificationList = (
    params?: GetApiCertificationListParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<CertificationDTOPaginationResult>(
      {url: `/api/Certification/list`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetApiCertificationListInfiniteQueryKey = (params?: GetApiCertificationListParams,) => {
    return [
    'infinite', `/api/Certification/list`, ...(params ? [params] : [])
    ] as const;
    }

export const getGetApiCertificationListQueryKey = (params?: GetApiCertificationListParams,) => {
    return [
    `/api/Certification/list`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiCertificationListInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getApiCertificationList>>>, TError = ProblemDetails>(params?: GetApiCertificationListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiCertificationList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCertificationListInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCertificationList>>> = ({ signal }) => getApiCertificationList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiCertificationList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCertificationListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCertificationList>>>
export type GetApiCertificationListInfiniteQueryError = ProblemDetails


export function useGetApiCertificationListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiCertificationList>>>, TError = ProblemDetails>(
 params: undefined |  GetApiCertificationListParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiCertificationList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCertificationList>>,
          TError,
          Awaited<ReturnType<typeof getApiCertificationList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCertificationListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiCertificationList>>>, TError = ProblemDetails>(
 params?: GetApiCertificationListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiCertificationList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCertificationList>>,
          TError,
          Awaited<ReturnType<typeof getApiCertificationList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCertificationListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiCertificationList>>>, TError = ProblemDetails>(
 params?: GetApiCertificationListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiCertificationList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCertificationListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiCertificationList>>>, TError = ProblemDetails>(
 params?: GetApiCertificationListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiCertificationList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCertificationListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetApiCertificationListQueryOptions = <TData = Awaited<ReturnType<typeof getApiCertificationList>>, TError = ProblemDetails>(params?: GetApiCertificationListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCertificationList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCertificationListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCertificationList>>> = ({ signal }) => getApiCertificationList(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCertificationList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCertificationListQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCertificationList>>>
export type GetApiCertificationListQueryError = ProblemDetails


export function useGetApiCertificationList<TData = Awaited<ReturnType<typeof getApiCertificationList>>, TError = ProblemDetails>(
 params: undefined |  GetApiCertificationListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCertificationList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCertificationList>>,
          TError,
          Awaited<ReturnType<typeof getApiCertificationList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCertificationList<TData = Awaited<ReturnType<typeof getApiCertificationList>>, TError = ProblemDetails>(
 params?: GetApiCertificationListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCertificationList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCertificationList>>,
          TError,
          Awaited<ReturnType<typeof getApiCertificationList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCertificationList<TData = Awaited<ReturnType<typeof getApiCertificationList>>, TError = ProblemDetails>(
 params?: GetApiCertificationListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCertificationList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCertificationList<TData = Awaited<ReturnType<typeof getApiCertificationList>>, TError = ProblemDetails>(
 params?: GetApiCertificationListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCertificationList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCertificationListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiCertificationAttempts = (
    params?: GetApiCertificationAttemptsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<CertificationAttemptDTOPaginationResult>(
      {url: `/api/Certification/attempts`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetApiCertificationAttemptsInfiniteQueryKey = (params?: GetApiCertificationAttemptsParams,) => {
    return [
    'infinite', `/api/Certification/attempts`, ...(params ? [params] : [])
    ] as const;
    }

export const getGetApiCertificationAttemptsQueryKey = (params?: GetApiCertificationAttemptsParams,) => {
    return [
    `/api/Certification/attempts`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiCertificationAttemptsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getApiCertificationAttempts>>>, TError = ProblemDetails>(params?: GetApiCertificationAttemptsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiCertificationAttempts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCertificationAttemptsInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCertificationAttempts>>> = ({ signal }) => getApiCertificationAttempts(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiCertificationAttempts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCertificationAttemptsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCertificationAttempts>>>
export type GetApiCertificationAttemptsInfiniteQueryError = ProblemDetails


export function useGetApiCertificationAttemptsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiCertificationAttempts>>>, TError = ProblemDetails>(
 params: undefined |  GetApiCertificationAttemptsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiCertificationAttempts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCertificationAttempts>>,
          TError,
          Awaited<ReturnType<typeof getApiCertificationAttempts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCertificationAttemptsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiCertificationAttempts>>>, TError = ProblemDetails>(
 params?: GetApiCertificationAttemptsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiCertificationAttempts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCertificationAttempts>>,
          TError,
          Awaited<ReturnType<typeof getApiCertificationAttempts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCertificationAttemptsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiCertificationAttempts>>>, TError = ProblemDetails>(
 params?: GetApiCertificationAttemptsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiCertificationAttempts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCertificationAttemptsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiCertificationAttempts>>>, TError = ProblemDetails>(
 params?: GetApiCertificationAttemptsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiCertificationAttempts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCertificationAttemptsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetApiCertificationAttemptsQueryOptions = <TData = Awaited<ReturnType<typeof getApiCertificationAttempts>>, TError = ProblemDetails>(params?: GetApiCertificationAttemptsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCertificationAttempts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCertificationAttemptsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCertificationAttempts>>> = ({ signal }) => getApiCertificationAttempts(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCertificationAttempts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCertificationAttemptsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCertificationAttempts>>>
export type GetApiCertificationAttemptsQueryError = ProblemDetails


export function useGetApiCertificationAttempts<TData = Awaited<ReturnType<typeof getApiCertificationAttempts>>, TError = ProblemDetails>(
 params: undefined |  GetApiCertificationAttemptsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCertificationAttempts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCertificationAttempts>>,
          TError,
          Awaited<ReturnType<typeof getApiCertificationAttempts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCertificationAttempts<TData = Awaited<ReturnType<typeof getApiCertificationAttempts>>, TError = ProblemDetails>(
 params?: GetApiCertificationAttemptsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCertificationAttempts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCertificationAttempts>>,
          TError,
          Awaited<ReturnType<typeof getApiCertificationAttempts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCertificationAttempts<TData = Awaited<ReturnType<typeof getApiCertificationAttempts>>, TError = ProblemDetails>(
 params?: GetApiCertificationAttemptsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCertificationAttempts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCertificationAttempts<TData = Awaited<ReturnType<typeof getApiCertificationAttempts>>, TError = ProblemDetails>(
 params?: GetApiCertificationAttemptsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCertificationAttempts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCertificationAttemptsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postApiCertificationReset = (
    resetCertificationRequest?: ResetCertificationRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<ResetCertificationResultDTO>(
      {url: `/api/Certification/reset`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: resetCertificationRequest, signal
    },
      options);
    }




export const getPostApiCertificationResetMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCertificationReset>>, TError,{data?: ResetCertificationRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiCertificationReset>>, TError,{data?: ResetCertificationRequest}, TContext> => {

const mutationKey = ['postApiCertificationReset'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCertificationReset>>, {data?: ResetCertificationRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiCertificationReset(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiCertificationResetMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCertificationReset>>>
    export type PostApiCertificationResetMutationBody = ResetCertificationRequest | undefined
    export type PostApiCertificationResetMutationError = ProblemDetails

    export const usePostApiCertificationReset = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCertificationReset>>, TError,{data?: ResetCertificationRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiCertificationReset>>,
        TError,
        {data?: ResetCertificationRequest},
        TContext
      > => {
      return useMutation(getPostApiCertificationResetMutationOptions(options), queryClient);
    }
    export const getApiCertificationId = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<CertificationDTO>(
      {url: `/api/Certification/${id}`, method: 'GET', signal
    },
      options);
    }




export const getGetApiCertificationIdInfiniteQueryKey = (id: string,) => {
    return [
    'infinite', `/api/Certification/${id}`
    ] as const;
    }

export const getGetApiCertificationIdQueryKey = (id: string,) => {
    return [
    `/api/Certification/${id}`
    ] as const;
    }


export const getGetApiCertificationIdInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getApiCertificationId>>>, TError = ProblemDetails>(id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiCertificationId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCertificationIdInfiniteQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCertificationId>>> = ({ signal }) => getApiCertificationId(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiCertificationId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCertificationIdInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCertificationId>>>
export type GetApiCertificationIdInfiniteQueryError = ProblemDetails


export function useGetApiCertificationIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiCertificationId>>>, TError = ProblemDetails>(
 id: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiCertificationId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCertificationId>>,
          TError,
          Awaited<ReturnType<typeof getApiCertificationId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCertificationIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiCertificationId>>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiCertificationId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCertificationId>>,
          TError,
          Awaited<ReturnType<typeof getApiCertificationId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCertificationIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiCertificationId>>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiCertificationId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCertificationIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiCertificationId>>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiCertificationId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCertificationIdInfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetApiCertificationIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiCertificationId>>, TError = ProblemDetails>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCertificationId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCertificationIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCertificationId>>> = ({ signal }) => getApiCertificationId(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCertificationId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCertificationIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCertificationId>>>
export type GetApiCertificationIdQueryError = ProblemDetails


export function useGetApiCertificationId<TData = Awaited<ReturnType<typeof getApiCertificationId>>, TError = ProblemDetails>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCertificationId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCertificationId>>,
          TError,
          Awaited<ReturnType<typeof getApiCertificationId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCertificationId<TData = Awaited<ReturnType<typeof getApiCertificationId>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCertificationId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCertificationId>>,
          TError,
          Awaited<ReturnType<typeof getApiCertificationId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCertificationId<TData = Awaited<ReturnType<typeof getApiCertificationId>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCertificationId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCertificationId<TData = Awaited<ReturnType<typeof getApiCertificationId>>, TError = ProblemDetails>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCertificationId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCertificationIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const deleteApiCertificationId = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/api/Certification/${id}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteApiCertificationIdMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiCertificationId>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiCertificationId>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteApiCertificationId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiCertificationId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteApiCertificationId(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiCertificationIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiCertificationId>>>

    export type DeleteApiCertificationIdMutationError = ProblemDetails

    export const useDeleteApiCertificationId = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiCertificationId>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiCertificationId>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteApiCertificationIdMutationOptions(options), queryClient);
    }
    export const getApiCertificationQuestions = (
    params?: GetApiCertificationQuestionsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<CertificationQuestion[]>(
      {url: `/api/Certification/questions`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetApiCertificationQuestionsInfiniteQueryKey = (params?: GetApiCertificationQuestionsParams,) => {
    return [
    'infinite', `/api/Certification/questions`, ...(params ? [params] : [])
    ] as const;
    }

export const getGetApiCertificationQuestionsQueryKey = (params?: GetApiCertificationQuestionsParams,) => {
    return [
    `/api/Certification/questions`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiCertificationQuestionsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getApiCertificationQuestions>>>, TError = unknown>(params?: GetApiCertificationQuestionsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiCertificationQuestions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCertificationQuestionsInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCertificationQuestions>>> = ({ signal }) => getApiCertificationQuestions(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiCertificationQuestions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCertificationQuestionsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCertificationQuestions>>>
export type GetApiCertificationQuestionsInfiniteQueryError = unknown


export function useGetApiCertificationQuestionsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiCertificationQuestions>>>, TError = unknown>(
 params: undefined |  GetApiCertificationQuestionsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiCertificationQuestions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCertificationQuestions>>,
          TError,
          Awaited<ReturnType<typeof getApiCertificationQuestions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCertificationQuestionsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiCertificationQuestions>>>, TError = unknown>(
 params?: GetApiCertificationQuestionsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiCertificationQuestions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCertificationQuestions>>,
          TError,
          Awaited<ReturnType<typeof getApiCertificationQuestions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCertificationQuestionsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiCertificationQuestions>>>, TError = unknown>(
 params?: GetApiCertificationQuestionsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiCertificationQuestions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCertificationQuestionsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiCertificationQuestions>>>, TError = unknown>(
 params?: GetApiCertificationQuestionsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiCertificationQuestions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCertificationQuestionsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetApiCertificationQuestionsQueryOptions = <TData = Awaited<ReturnType<typeof getApiCertificationQuestions>>, TError = unknown>(params?: GetApiCertificationQuestionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCertificationQuestions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCertificationQuestionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCertificationQuestions>>> = ({ signal }) => getApiCertificationQuestions(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCertificationQuestions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCertificationQuestionsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCertificationQuestions>>>
export type GetApiCertificationQuestionsQueryError = unknown


export function useGetApiCertificationQuestions<TData = Awaited<ReturnType<typeof getApiCertificationQuestions>>, TError = unknown>(
 params: undefined |  GetApiCertificationQuestionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCertificationQuestions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCertificationQuestions>>,
          TError,
          Awaited<ReturnType<typeof getApiCertificationQuestions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCertificationQuestions<TData = Awaited<ReturnType<typeof getApiCertificationQuestions>>, TError = unknown>(
 params?: GetApiCertificationQuestionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCertificationQuestions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCertificationQuestions>>,
          TError,
          Awaited<ReturnType<typeof getApiCertificationQuestions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCertificationQuestions<TData = Awaited<ReturnType<typeof getApiCertificationQuestions>>, TError = unknown>(
 params?: GetApiCertificationQuestionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCertificationQuestions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCertificationQuestions<TData = Awaited<ReturnType<typeof getApiCertificationQuestions>>, TError = unknown>(
 params?: GetApiCertificationQuestionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCertificationQuestions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCertificationQuestionsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postApiCertificationQuestions = (
    createCertificationQuestionRequest?: CreateCertificationQuestionRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<CertificationQuestion>(
      {url: `/api/Certification/questions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createCertificationQuestionRequest, signal
    },
      options);
    }




export const getPostApiCertificationQuestionsMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCertificationQuestions>>, TError,{data?: CreateCertificationQuestionRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiCertificationQuestions>>, TError,{data?: CreateCertificationQuestionRequest}, TContext> => {

const mutationKey = ['postApiCertificationQuestions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCertificationQuestions>>, {data?: CreateCertificationQuestionRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiCertificationQuestions(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiCertificationQuestionsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCertificationQuestions>>>
    export type PostApiCertificationQuestionsMutationBody = CreateCertificationQuestionRequest | undefined
    export type PostApiCertificationQuestionsMutationError = ProblemDetails

    export const usePostApiCertificationQuestions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCertificationQuestions>>, TError,{data?: CreateCertificationQuestionRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiCertificationQuestions>>,
        TError,
        {data?: CreateCertificationQuestionRequest},
        TContext
      > => {
      return useMutation(getPostApiCertificationQuestionsMutationOptions(options), queryClient);
    }
    export const putApiCertificationQuestionsId = (
    id: string,
    updateCertificationQuestionRequest?: UpdateCertificationQuestionRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<CertificationQuestion>(
      {url: `/api/Certification/questions/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateCertificationQuestionRequest, signal
    },
      options);
    }




export const getPutApiCertificationQuestionsIdMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiCertificationQuestionsId>>, TError,{id: string;data?: UpdateCertificationQuestionRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putApiCertificationQuestionsId>>, TError,{id: string;data?: UpdateCertificationQuestionRequest}, TContext> => {

const mutationKey = ['putApiCertificationQuestionsId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiCertificationQuestionsId>>, {id: string;data?: UpdateCertificationQuestionRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  putApiCertificationQuestionsId(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutApiCertificationQuestionsIdMutationResult = NonNullable<Awaited<ReturnType<typeof putApiCertificationQuestionsId>>>
    export type PutApiCertificationQuestionsIdMutationBody = UpdateCertificationQuestionRequest | undefined
    export type PutApiCertificationQuestionsIdMutationError = ProblemDetails

    export const usePutApiCertificationQuestionsId = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiCertificationQuestionsId>>, TError,{id: string;data?: UpdateCertificationQuestionRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putApiCertificationQuestionsId>>,
        TError,
        {id: string;data?: UpdateCertificationQuestionRequest},
        TContext
      > => {
      return useMutation(getPutApiCertificationQuestionsIdMutationOptions(options), queryClient);
    }
    export const deleteApiCertificationQuestionsId = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<CertificationQuestion>(
      {url: `/api/Certification/questions/${id}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteApiCertificationQuestionsIdMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiCertificationQuestionsId>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiCertificationQuestionsId>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteApiCertificationQuestionsId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiCertificationQuestionsId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteApiCertificationQuestionsId(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiCertificationQuestionsIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiCertificationQuestionsId>>>

    export type DeleteApiCertificationQuestionsIdMutationError = ProblemDetails

    export const useDeleteApiCertificationQuestionsId = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiCertificationQuestionsId>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiCertificationQuestionsId>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteApiCertificationQuestionsIdMutationOptions(options), queryClient);
    }
